import React from "react";
import "./Dashboard.css";
import { useApp } from "./../../../AppProvider";
import Avatar from '@mui/material/Avatar';
import { getPatientAge } from "../../../Utils";

const Dashboard = () => {
  const { selectedPatientObj, patientsMedicine, stringAvatar, stringToColor } = useApp();

  // console.log("selectedPatientObj=======", selectedPatientObj);
  // console.log("Patients Ongoing Medicine ==>", patientsMedicine);

  function availableCondition(condition) {
    return condition !== null && condition !== undefined ? condition : "NA";
  }

  const heridityTags = selectedPatientObj?.heridityTags || [];

  return (
    <div className="dashboadr_container">
      <div className="left_section">
        <div className="top">
          <Avatar sx={{ width: { md: 80, lg: 90, xl: 120 }, height: { md: 80, lg: 90, xl: 120 }, marginBottom: 1, bgcolor: selectedPatientObj?.img ? 'transparent' : stringToColor(selectedPatientObj?.name?.firstName) }}
            alt={selectedPatientObj?.name?.firstName ?? null}
            src={selectedPatientObj?.img ?? null} >
            {!(selectedPatientObj?.img ?? null) && stringAvatar(selectedPatientObj?.name?.firstName ?? null).children}
          </Avatar>
          <h3>
            {selectedPatientObj && selectedPatientObj.name
              ? `${selectedPatientObj.name.firstName || ''} ${selectedPatientObj.name.middleName || ''} ${selectedPatientObj.name.lastName || ''}`
              : 'Patient Name'}
          </h3>

        </div>
        <div className="bottom">
          {/* GENERAL INFO */}
          <div className="general-info">
            <span className="title-tag">General Info</span>
            <table className="info">
              <tr>
                <td className="filled">Gender</td>
                <td className="input">
                  {selectedPatientObj ? availableCondition(selectedPatientObj.gender) : "NA"}
                </td>
              </tr>
              <tr>
                <td className="filled">Age</td>
                <td className="input">
                  {selectedPatientObj ? getPatientAge(selectedPatientObj) : "NA"}
                </td>
              </tr>
              <tr>
                <td className="filled">Weight</td>
                <td className="input">
                  {selectedPatientObj ? availableCondition(selectedPatientObj.weight) : "NA"}
                </td>
              </tr>
              <tr>
                <td className="filled">Blood Group</td>
                <td className="input">
                  {selectedPatientObj ? availableCondition(selectedPatientObj.bloodGroup) : "NA"}
                </td>
              </tr>
              <tr>
                <td className="filled">Phone</td>
                <td className="input">
                  {selectedPatientObj ? availableCondition(selectedPatientObj.contact.phoneNumber.phoneNumber) : "NA"}
                </td>
              </tr>
            </table>
          </div>

          {/* MEDICAL CONDITIONS */}
          <div className="general-info">
            <span className="title-tag">Medical Conditions</span>
            <div className="medical-condition_container">
              {selectedPatientObj &&
                selectedPatientObj.chronicConditions &&
                selectedPatientObj.chronicConditions.length > 0 ? (
                selectedPatientObj.chronicConditions.map((condition, index) => (
                  <div className="medical-input" key={index}>{condition}</div>
                ))
              ) : (
                <div className="sidebar-data-not-available">
                  Data Not Available
                </div>
              )}
            </div>
          </div>
          {/* ALLERGIES */}
          <div className="general-info">
            <span className="title-tag">Allergies</span>
            <div className="allergies-container">
              {selectedPatientObj && selectedPatientObj.allergies ? (
                selectedPatientObj.allergies.map((value, index) => (
                  <div className="allergies-input" key={index}>
                    {value}
                  </div>
                ))
              ) : (
                <div className="sidebar-data-not-available">
                  Data Not Available
                </div>
              )}
            </div>
          </div>
          {/* ADDICTIVE HABBITS */}
          <div className="general-info">
            <span className="title-tag">Addictive Habits</span>
            <div className="addictive-habbits-container">
              {selectedPatientObj && selectedPatientObj.addictionInformation ? (
                Object.values(selectedPatientObj.addictionInformation).some(val => val) ? (
                  Object.entries(selectedPatientObj.addictionInformation).map(([key, value], index) => (
                    <div className="addictive-habbit" key={index}>
                      <span className="filled">{key.charAt(0).toUpperCase() + key.slice(1)}:</span> {value}
                    </div>
                  ))
                ) : (
                  <div className="sidebar-data-not-available-habbits">
                    Data Not Available
                  </div>
                )
              ) : (
                <div className="sidebar-data-not-available-habbits">
                  Data Not Available
                </div>
              )}
            </div>
          </div>
          <div className="general-info">
            <span className="title-tag">Ongoing Medication</span>
            <div className="ongingmedication-container">
              {patientsMedicine && patientsMedicine.length > 0 ? (
                patientsMedicine.map((medication, index) => (
                  <div className="ongoing-input" key={index} data-drug={medication.drug}>
                    {index + 1}. {medication.drug}
                  </div>
                ))
              ) : (
                <div className="sidebar-data-not-available">
                  Data Not Available
                </div>
              )}
            </div>
          </div>
          <div className="general-info">
            <span className="title-tag">Heredity</span>
            <div className="heredity-input-div">
              {heridityTags.length > 0 ? (
                heridityTags.map((tag, index) => (
                  <div className="heredity-input" key={index}>
                    {tag}
                  </div>
                ))
              ) : (
                <div className="sidebar-data-not-available">
                  Data Not Available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
